import { render, staticRenderFns } from "./wtCropping.component.vue?vue&type=template&id=2dd703b0&scoped=true&"
import script from "./wtCropping.component.vue?vue&type=script&lang=js&"
export * from "./wtCropping.component.vue?vue&type=script&lang=js&"
import style0 from "./wtCropping.component.vue?vue&type=style&index=0&id=2dd703b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd703b0",
  null
  
)

export default component.exports